import React, { Fragment } from "react";

import { Sidebar } from "./Sidebar";

interface IStandardLayoutProps {
    children: React.ReactNode;
}

export function StandardLayout(props: IStandardLayoutProps) {
    const { children } = props;
    return (
        <>
            <Sidebar key="sidebar" />
            <Fragment key="content">{children}</Fragment>
        </>
    );
}
